import { IconProps } from "../../utils/global-types/global-types";

const CommunicationAllIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className || "w-5 h-5"}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      className="fill-[#252B37] dark:fill-[#fff]"
      d="M11.968 1.917c2.578 0 4.115 1.537 4.108 4.115v5.936c0 2.578-1.537 4.115-4.115 4.115H6.032c-2.578 0-4.115-1.537-4.115-4.122V6.032c0-2.578 1.537-4.115 4.115-4.115z"
    ></path>
    <path
      className="fill-[#fff] dark:fill-[#252B37]"
      d="M5.235 10.303a.477.477 0 0 0 .673 0L9.95 6.26a.476.476 0 0 0-.673-.674L5.235 9.629a.477.477 0 0 0 0 .674"
    ></path>
    <path
      className="fill-[#fff] dark:fill-[#252B37]"
      d="M5.235 10.303a.47.47 0 0 0 .337.14h2.694a.476.476 0 1 0 0-.954H6.048V7.271a.476.476 0 1 0-.953 0v2.695a.47.47 0 0 0 .14.337M13.144 8.198a.477.477 0 0 0-.673 0l-4.042 4.041a.477.477 0 0 0 .673.674l4.042-4.042a.477.477 0 0 0 0-.674"
    ></path>
    <path
      className="fill-[#fff] dark:fill-[#252B37]"
      d="M13.144 8.198a.47.47 0 0 0-.337-.14h-2.694a.476.476 0 1 0 0 .953h2.218v2.218a.476.476 0 0 0 .953 0V8.534a.47.47 0 0 0-.14-.336"
    ></path>
  </svg>
);
};
export default CommunicationAllIcon;
